export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtDokladsk';
export const NAME = 'SkupinaDokladu';
